/* eslint-disable prettier/prettier */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import CardContent from "@mui/material/CardContent";
import { Table, TableBody } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useMutation } from "@apollo/client";
import GET_USER_GUIDE from "src/graphql/query/user_guide/getUserGuide";
import { useSelector } from "react-redux";
import { useTour } from "src/context/global/TourContext";
import DISCONNECT_PAGE from "src/graphql/mutation/settings/disconnectPage";
import CONNECT_PAGE from "src/graphql/mutation/settings/connectPage";
import DELETE_PAGE from "src/graphql/mutation/settings/deletePage";
import CancelIcon from "@mui/icons-material/Cancel";
import AddTaskIcon from "@mui/icons-material/AddTask";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DialogBoxLayout from "src/components/shared/atoms/dialog";
import InternalRow from "./row";
import BotConfigModal from "../../../chatbot/shared/BotConfigModal";
import useStyle from "./Styles";

interface Props {
  pagesData: any;
  setPagesData: (value: any) => void;
}

const InternalPage: React.FC<Props> = ({ pagesData, setPagesData }) => {
  const { classes } = useStyle();
  const { me }: any = useSelector((state: any) => state.me);
  const {
    postFbConnectionTourRun,
    startPostFbConnectionTour,
    stopPostFbConnectionTour,
    setPostFbConnectionStepIndex,
  } = useTour();

  const { enqueueSnackbar } = useSnackbar();
  const [removeModal, setRemoveModal] = useState(false);
  const closeDeleteDialog = () => setRemoveModal(false);
  const [disconnectModal, setDisconnectModal] = useState(false);
  const [connectModal, setConnectModal] = useState(false);
  const closeRemoveDialog = () => setDisconnectModal(false);
  const [wasTourRunning, setWasTourRunning] = useState(false);

  const closeConnectDialog = () => {
    setConnectModal(false);
    // Resume tour if it was running before modal opened
    if (wasTourRunning) {
      startPostFbConnectionTour();
      setWasTourRunning(false);
    }
  };
  const [actionPageData, setActionPageData] = useState<string | null>(null);

  // Bot Config Modal State
  const [configModalOpen, setConfigModalOpen] = useState(false);
  const [selectedPageForConfig, setSelectedPageForConfig] = useState<any>(null);

  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  const handleConfigBot = (page: any) => {
    setSelectedPageForConfig(page);
    setConfigModalOpen(true);
  };

  const handleToggleBot = (pageId: string, enabled: boolean) => {
    setPagesData((prev: any[]) =>
      prev.map((p) =>
        p.pageId === pageId ? { ...p, botEnabled: enabled } : p,
      ),
    );
    // TODO: Persist via mutation
    enqueueSnackbar(`Bot ${enabled ? "enabled" : "disabled"} for account`, {
      variant: "success",
    });
  };
  const [
    disconnectPage,
    {
      loading: disConnectPageMutationLoading,
      data: disConnectPageMutationResult,
    },
  ] = useMutation(DISCONNECT_PAGE);

  useEffect(() => {
    if (
      disConnectPageMutationResult &&
      disConnectPageMutationResult.disconnectPage
    ) {
      if (disConnectPageMutationResult.disconnectPage.success) {
        const updatedPagesData =
          pagesData && pagesData.length
            ? pagesData.map((element: { pageId: undefined }) => {
                if (element.pageId === actionPageData)
                  return {
                    ...element,
                    isSelected: false,
                  };
                return element;
              })
            : [];

        setPagesData(updatedPagesData);

        enqueueSnackbar(
          JSON.parse(disConnectPageMutationResult.disconnectPage.result),
          {
            variant: "info",
          },
        );
      } else {
        enqueueSnackbar(
          JSON.parse(disConnectPageMutationResult.disconnectPage.error),
          {
            variant: "error",
          },
        );
      }
      closeRemoveDialog();
    }
  }, [disConnectPageMutationResult]);

  const [
    connectPage,
    { loading: connectPageMutationLoading, data: connectPageMutationResult },
  ] = useMutation(CONNECT_PAGE, {
    update(cache) {
      if (!me?.id) return;

      const existing = cache.readQuery({
        query: GET_USER_GUIDE,
        variables: { agentId: me.id },
      }) as any;

      if (!existing?.getUserGuide) return;

      cache.writeQuery({
        query: GET_USER_GUIDE,
        variables: { agentId: me.id },
        data: {
          getUserGuide: {
            ...existing.getUserGuide,
            channelConnected: true,
          },
        },
      });
    },
  });

  useEffect(() => {
    if (connectPageMutationResult && connectPageMutationResult.connectPage) {
      if (connectPageMutationResult.connectPage.success) {
        const updatedPagesData =
          pagesData && pagesData.length
            ? pagesData.map((element: { pageId: undefined }) => {
                if (element.pageId === actionPageData) {
                  return {
                    ...element,
                    isSelected: true,
                  };
                }
                return element;
              })
            : [];
        setPagesData(updatedPagesData);

        enqueueSnackbar(
          JSON.parse(connectPageMutationResult.connectPage.result),
          {
            variant: "info",
          },
        );

        // Advance onboarding tour to step 2 if it was running
        if (wasTourRunning) {
          setTimeout(() => {
            setPostFbConnectionStepIndex(1);
          }, 500);
        }
      } else {
        enqueueSnackbar(
          JSON.parse(connectPageMutationResult.connectPage.error),
          {
            variant: "error",
          },
        );
      }
      closeConnectDialog();
    }
  }, [connectPageMutationResult]);

  const [
    deletepage,
    { data: deletepageMutationResult, loading: deletepageMutationLoading },
  ] = useMutation(DELETE_PAGE);

  useEffect(() => {
    if (deletepageMutationResult && deletepageMutationResult.deletepage) {
      if (deletepageMutationResult.deletepage.success) {
        const pagesDataWithoutCurrData: any =
          pagesData &&
          pagesData.length &&
          pagesData.filter((curr: any) => curr.pageId !== actionPageData);
        setPagesData(pagesDataWithoutCurrData);
        enqueueSnackbar("page has been removed", { variant: "success" });
      } else {
        enqueueSnackbar(JSON.parse(deletepageMutationResult.deletepage.error), {
          variant: "error",
        });
      }
      closeDeleteDialog();
    }
  }, [deletepageMutationResult]);

  const disConnectApiCallHandler = async () => {
    try {
      await disconnectPage({
        variables: {
          pageId: actionPageData,
        },
      });
    } catch (err: any) {
      enqueueSnackbar("Something went wrong. Try again", {
        variant: "error",
      });
    }
  };
  const removeApiCallHandler = async () => {
    try {
      await deletepage({
        variables: {
          pageId: actionPageData,
        },
      });
    } catch (err: any) {
      enqueueSnackbar("Something went wrong. Try again", {
        variant: "error",
      });
    }
  };
  const connectApiCallHandler = async () => {
    try {
      await connectPage({
        variables: {
          pageId: actionPageData,
        },
      });
    } catch (err: any) {
      enqueueSnackbar("Something went wrong. Try again", {
        variant: "error",
      });
    }
  };

  const disconnectedHandler = (data: any) => {
    setDisconnectModal(true);
    setActionPageData(data.pageId);
  };

  const closeHandler = (data: any) => {
    setRemoveModal(true);
    setActionPageData(data.pageId);
  };

  const connectedHandler = (data: any) => {
    setConnectModal(true);
    setActionPageData(data.pageId);
    // Pause tour to avoid overlap with modal
    if (postFbConnectionTourRun) {
      setWasTourRunning(true);
      stopPostFbConnectionTour();
    }
  };

  return (
    <>
      <CardContent className={classes.cardContent}>
        <Table className={classes.tableStyle}>
          <TableBody>
            {pagesData.map((curr: any, index: number) => {
              return (
                <InternalRow
                  key={curr?.pageId}
                  id={index === 0 ? "tour-connect-page-button" : undefined}
                  loading={
                    (connectPageMutationLoading ||
                      disConnectPageMutationLoading) &&
                    actionPageData === curr?.pageId
                  }
                  disabled={
                    (connectPageMutationLoading ||
                      disConnectPageMutationLoading) &&
                    actionPageData === curr?.pageId
                  }
                  connectedHandler={connectedHandler}
                  disconnectedHandler={disconnectedHandler}
                  curr={curr}
                  closeHandler={closeHandler}
                  // onConfigBot={() => handleConfigBot(curr)}
                  // onToggleBot={(enabled) =>
                  //   handleToggleBot(curr.pageId, enabled)
                  // }
                  // canEnable={curr.hasData || curr.botEnabled}
                />
              );
            })}
          </TableBody>
        </Table>
      </CardContent>

      <BotConfigModal
        open={configModalOpen}
        onClose={() => setConfigModalOpen(false)}
        entityName={selectedPageForConfig?.name || ""}
        entityId={selectedPageForConfig?.pageId || ""}
        entityType="facebook"
        onDataAdded={() => {
          if (selectedPageForConfig) {
            handleToggleBot(selectedPageForConfig.pageId, false); // Just to refresh or maintain state
            setPagesData((prev: any[]) =>
              prev.map((p) =>
                p.pageId === selectedPageForConfig.pageId
                  ? { ...p, hasData: true }
                  : p,
              ),
            );
          }
        }}
      />
      {removeModal && (
        <DialogBoxLayout
          title="Remove Connection"
          btnText="Remove"
          icon={
            <DeleteForeverIcon sx={{ color: "#E34D59", fontSize: "40px" }} />
          }
          open={removeModal}
          actionHandler={removeApiCallHandler}
          text="This will completely remove the page from your account. Do you wish to proceed?"
          modalClose={closeDeleteDialog}
          loader={deletepageMutationLoading}
        />
      )}

      {disconnectModal && (
        <DialogBoxLayout
          title="Disconnect Page"
          btnText="Disconnect"
          icon={<CancelIcon sx={{ color: "#E34D59", fontSize: "40px" }} />}
          open={disconnectModal}
          actionHandler={disConnectApiCallHandler}
          text="This page will stop receiving messages until reconnected. Continue?"
          modalClose={closeRemoveDialog}
          loader={disConnectPageMutationLoading}
        />
      )}
      {connectModal && (
        <DialogBoxLayout
          title="Connect Page"
          btnText="Connect Now"
          icon={<AddTaskIcon sx={{ color: "#4D1277", fontSize: "40px" }} />}
          open={connectModal}
          actionHandler={connectApiCallHandler}
          text="Confirming this will enable message synchronization for this page."
          modalClose={closeConnectDialog}
          loader={connectPageMutationLoading}
        />
      )}
    </>
  );
};

export default InternalPage;
